import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import WN_logo from "./WN_logo.svg"; /** Logo */
import amsterdam from "./amsterdam.jpg";
import managed_servicer from "./Managed_Services.svg"; /* Icon img */
import Workplace_Management from "./Workplace_Management.svg"; /** Icon img */
import Azure_AWS_GCP from "./Azure_AWS_GCP.svg"; /** Icon img */
import Infra_Support from "./24x7_Infra_Support_&_SOC.svg"; /** Icon img */
import Product from "./Product_ Maintenance_&_support.svg"; /** Icon img */
import Dedicated_Developers from "./Dedicated_Developers.svg"; /** Icon img */
import DAAS from "./DAAS_(Department_as_a_Service).svg"; /** Icon img */
import C2H from "./C2H(Contract_to_Hire).svg"; /** Icon img */
import BOT from "./BOT_(Build-Operate-Transfer).svg"; /** Icon img */
import Setting_up_GCCs_in_India from "./Setting_up_GCCs_in_India.svg"; /** Icon img */
import email_icon from "./Email-Icon.svg";
import calender_icon from "./Calender-icon.svg";
import Future_nomad_1 from "./Future_nomad_1.jpg";
import Future_nomad_2 from "./Future_nomad_2.jpg";
import Future_nomad_3 from "./Future_nomad_3.jpg";
import location_icon from "./Location_icon.svg";
import cybersecurity from './cybersecurity.svg';
import data from './data.svg';
import automation from './automation.svg';
import gcc from './gcc.svg';
import modernWorkplace from './modern-workplace.svg';
import managedService from './ai-managed-services.svg';

function App() {
  function handleDownload() {
    const link = document.createElement('a');
    link.href = '/WesternNomads_PrivacyPolicy_2025.pdf'; // relative to the public folder
    link.download = 'WesternNomads_PrivacyPolicy_2025.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  return (
    <div className="App">
      {/* Logo section */}

      {/* Header Section */}
      <div className="container-fluid">
        <div className="row row-section-1 ">
          {/* Logo Section */}
          <div className="col-lg-4 logo-column">
            <div className="container-style container-header d-flex align-items-center justify-content-center">
              <div className="logo_container">
                <div className="logo-img align-items-center">
                  <img
                    src={WN_logo}
                    alt="Western Nomads Logo"
                    className="w-100"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Subtitle & CTA Section */}
          <div className="col-lg-8">
            <div className="container-style container-header ">
              <div className="header-subtitle d-flex justify-content-between align-items-center w-100">
                <div className="subtitle">
                  <p className="m-0">
                    European ICT Workforce & Managed Services Partner
                  </p>
                </div>
                <button className="header-action-button" onClick={() => window.open('https://calendar.app.google/suZkFq5rS5MYbJyg9', '_blank', 'noopener,noreferrer')}>Let's Talk</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 1 */}
      <div className="container-fluid">
        <div className="row row-section-2">
          {/* Left: Text with Image */}
          <div className="col-xl-6 ">
            <div className="container-fluid container-style container-section-1 h-100">
              <div className="row h-100 ">
                <div className="col-xl-7 d-flex flex-column justify-content-center">
                  <div className="container-title">
                    <p className="title-text m-0">
                      Built Through Bonds, Not Bids
                    </p>
                  </div>
                  <div className="container-content">
                    <p>
                      At Western Nomads, we believe business happens through people, physical bonds and long term relationships.
                    </p>
                    <p>
                      We're a people-first partner built on 15+ years of
                      experience in the European ICT space where we have built
                      distributed teams, led transformations, and delivered
                      outcomes across industries, from enterprise cloud to
                      digital product development.
                      <br />
                      We're your extended brain, your feet on the ground, and
                      your people in action.
                    </p>
                  </div>
                </div>
                <div className="col-xl-5 d-flex align-items-center pr-10;">
                  <img
                    src={amsterdam}
                    alt="Amsterdam"
                    className="img_amsterdam w-100 h-100"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right: What We Do Icons Grid */}
          <div className="col-xl-6 services-grid">
            <div className="container-fluid container-style container-section-1 h-100">
              <div className="container-title">
                <h3 className="title-text m-0">What We Do</h3>
              </div>
              <div className="services-box-container">
                <div className="row box-row">
                  {/* Repeatable Service Icon Box */}
                  {[
                    {
                      src: automation,
                      text: "AI & Automation Consulting",
                    },
                    { src: managedService, text: "AI Managed Services" },
                    { src: modernWorkplace, text: "Modern Workplace & Copilot" },
                    { src: Azure_AWS_GCP, text: "Cloud & Platform Engineering" },
                    { src: cybersecurity, text: "Cybersecurity & Managed SOC" },
                    { src: Product, text: "Application Modernization" },
                    { src: Dedicated_Developers, text: "Digital Engineering Teams" },
                    { src: data, text: "Data & AI Platforms" },
                    { src: C2H, text: "Talent Solutions & GCC Scaling" },
                    { src: gcc, text: "Global Capability Centers (GCC)" },
                  ].map((item, index) => (
                    <div
                      className="col-md-3 text-center box-grid-item"
                      key={index}
                    >
                      <div className="icon-container">
                        <div className="services_box pt-2 d-flex flex-column align-items-center">
                          <img
                            src={item.src}
                            alt={item.text}
                            className="icon-img"
                          />
                          <p className="text-muted icon_text mt-2">
                            {item.text}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 */}
      <div className="container-fluid">
        <div className="row row-section-3">
          <div className="col-xl-4 why-grid">
            <div className="container-style container-section-2">
              <div className="container-title">
                <p className="title-text m-0">Why Western Nomads?</p>
              </div>
              <ul className="checked-list-block">
                <li className="list-item">
                  <span className="item-title">
                    Built on Trust, Not Tenders
                  </span>
                  <span className="item-subtitle">
                    We grow through referrals, relationships, and results. (not
                    cold leads)
                  </span>
                </li>
                <li className="list-item">
                  <span className="item-title">
                    Agility of a Startup, Maturity of Experience
                  </span>
                  <span className="item-subtitle">
                    We move fast without cutting corners.
                  </span>
                </li>
                <li className="list-item">
                  <span className="item-title">Sharp, Vetted Talent</span>
                  <span className="item-subtitle">
                    No bench fillers. Only people who know their craft.
                  </span>
                </li>
                <li className="list-item">
                  <span className="item-title">Less Talk, More Build</span>
                  <span className="item-subtitle">
                    We don't just strategize we ship. Quickly, cleanly, and
                    without the drama.
                  </span>
                </li>
                <li className="list-item">
                  <span className="item-title">We Show Up</span>
                  <span className="item-subtitle">
                    We meet in person, visit your office, and build real
                    context.
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 col-xl-4">
            <div className="container-style container-section-2 d-flex flex-column">
              <div className="content">
                <div className="container-title">
                  <p className="title-text">No pitch decks. No fluff.</p>
                </div>
                <div className="container-content">
                  <p>We skip the buzzwords and the bureaucracy.</p>
                  <p>
                    You won't find endless slides, templated pitches, or hollow
                    promises here. Instead, we believe in authentic conversations
                    that build trust, real stories that reflect impact, and
                    actions that speak louder than presentations.
                  </p>
                  <p>
                    Let's talk human to human.
                  </p>
                </div>
              </div>

              <div className="button-wrapper pt-4 mt-auto">
                <button className="btn-primary" onClick={() => {
                  window.location.href = 'mailto:info@westernnomads.com';
                }}
                >
                  <img src={email_icon} alt="email-icon" />
                  Email us
                </button>
                <button className="btn-secondary" onClick={() => window.open('https://calendar.app.google/suZkFq5rS5MYbJyg9', '_blank', 'noopener,noreferrer')}>
                  <img src={calender_icon} alt="calender_icon" />
                  Schedule a Call
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-4 user-profile-grid">
            <div className="container-style container-section-2">
              <div className="image-wrapper"></div>
              <div className="contact-details">
                <p className="contact-title">Ninad Patki</p>
                <p className="contact-subtitle">CEO</p>
                <div className="social-icons">
                  <svg onClick={() => window.open('https://www.linkedin.com/in/ninadpatki/', '_blank', 'noopener,noreferrer')} className="linked-in-dark m-0" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.3333 4C26.0406 4 26.7189 4.28095 27.219 4.78105C27.719 5.28115 28 5.95942 28 6.66667V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H25.3333ZM24.6667 24.6667V17.6C24.6667 16.4472 24.2087 15.3416 23.3936 14.5264C22.5784 13.7113 21.4728 13.2533 20.32 13.2533C19.1867 13.2533 17.8667 13.9467 17.2267 14.9867V13.5067H13.5067V24.6667H17.2267V18.0933C17.2267 17.0667 18.0533 16.2267 19.08 16.2267C19.5751 16.2267 20.0499 16.4233 20.3999 16.7734C20.75 17.1235 20.9467 17.5983 20.9467 18.0933V24.6667H24.6667ZM9.17333 11.4133C9.76742 11.4133 10.3372 11.1773 10.7573 10.7573C11.1773 10.3372 11.4133 9.76742 11.4133 9.17333C11.4133 7.93333 10.4133 6.92 9.17333 6.92C8.57571 6.92 8.00257 7.1574 7.57999 7.57999C7.1574 8.00257 6.92 8.57571 6.92 9.17333C6.92 10.4133 7.93333 11.4133 9.17333 11.4133ZM11.0267 24.6667V13.5067H7.33333V24.6667H11.0267Z" fill="#5E5E5E" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3 */}
      <div className="container-fluid">
        <div className="row row-section-4">
          <div className="col-md-12">
            <div className="container-style">
              {/* Left with Image */}
              <div className="col-xl-6">
                <div className="image-container">
                  <div className="image-block container-left">
                    <img alt="Work from any where" src={Future_nomad_1} />
                  </div>
                  <div className="image-block container-right">
                    <img alt="Team meeting" src={Future_nomad_2} />
                    <img alt="Team meeting" src={Future_nomad_3} />
                  </div>
                </div>
              </div>

              {/* Right: Are You a Future Nomad */}
              <div className="col-xl-6 future-nomad-container bg-light rounded-right">
                <div className="container-section-4">
                  <div className="container-title">
                    <h3 className="title-text m-0 text-dark">
                      Are You a Future Nomad?
                    </h3>
                  </div>
                  <div className="container-content d-flex flex-column">
                    <div className="container-content-text">
                      <p>
                        We're not just building teams. We're building a tribe of
                        bold, skilled professionals who can deliver European-grade
                        quality and thrive in the real world, not just behind
                        screens. If you're passionate about meaningful work,
                        curious about the world, and ready to collaborate beyond
                        borders you might already be one of us.
                      </p>
                      <p>
                        By default, you've got to be a traveler at heart, explorer
                        in mind. As our meetings don't always happen in conference
                        rooms. They happen in the mountains, by the sea, in wild
                        jungle safaris or around a desert campfire.
                      </p>
                      <p>That's where Nomads come alive.</p>
                    </div>
                    <div className="mt-auto">
                      <button className="btn-secondary" onClick={() => {
                        window.location.href = 'mailto:info@westernnomads.com';
                      }}>Join the Tribe</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*footer*/}
      <div className="container-fluid">
        <div className="row row-section-6">
          <div className="col-md-12">
            <div className="container-style container-footer ">
              <div className="footer-block-row">
                <div className="footer-block-primary">
                  <div className="icon-wrapper">
                    <img
                      src={location_icon}
                      alt="location-icon"
                      className="justify-content-top pb-5"
                    />
                  </div>
                  <div className="footer-address">
                    <div>
                      <h6 className="footer-title">Registered office: </h6>
                      <p className="text-muted footer-text">
                        Flat 2, 1st Floor, Shreeniwas Residency, ShantiSheela
                        Society,
                        <br />
                        Law college Road, Pune 411004, Maharashtra, India.
                        <br />
                        Corporate Identity Number (CIN): U62099PN2023PTC224419{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="footer-logo">
                  <img
                    src={WN_logo}
                    alt="WN-logo"
                    className="footer-logo-img"
                  />
                </div>
              </div>
              <hr />
              <div className="footer-block-row">
                <div className="footer-sub-block">
                  <p className="footer-disclaimer">
                    © 2026 Western Nomads Pvt. Ltd.
                  </p>
                  <div className="footer-links">
                    <span className="footer-link" onClick={handleDownload} >Privacy Policy</span>
                    <svg onClick={() => window.open('https://www.linkedin.com/company/westernnomads/', '_blank', 'noopener,noreferrer')} className="linked-in-dark" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M25.3333 4C26.0406 4 26.7189 4.28095 27.219 4.78105C27.719 5.28115 28 5.95942 28 6.66667V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H25.3333ZM24.6667 24.6667V17.6C24.6667 16.4472 24.2087 15.3416 23.3936 14.5264C22.5784 13.7113 21.4728 13.2533 20.32 13.2533C19.1867 13.2533 17.8667 13.9467 17.2267 14.9867V13.5067H13.5067V24.6667H17.2267V18.0933C17.2267 17.0667 18.0533 16.2267 19.08 16.2267C19.5751 16.2267 20.0499 16.4233 20.3999 16.7734C20.75 17.1235 20.9467 17.5983 20.9467 18.0933V24.6667H24.6667ZM9.17333 11.4133C9.76742 11.4133 10.3372 11.1773 10.7573 10.7573C11.1773 10.3372 11.4133 9.76742 11.4133 9.17333C11.4133 7.93333 10.4133 6.92 9.17333 6.92C8.57571 6.92 8.00257 7.1574 7.57999 7.57999C7.1574 8.00257 6.92 8.57571 6.92 9.17333C6.92 10.4133 7.93333 11.4133 9.17333 11.4133ZM11.0267 24.6667V13.5067H7.33333V24.6667H11.0267Z" fill="#5E5E5E" />
                    </svg>
                    <svg onClick={() => {
                      window.location.href = 'mailto:info@westernnomads.com';
                    }} className="email-dark" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M26.6666 10.6666L16 17.3333L5.33329 10.6666V7.99998L16 14.6666L26.6666 7.99998M26.6666 5.33331H5.33329C3.85329 5.33331 2.66663 6.51998 2.66663 7.99998V24C2.66663 24.7072 2.94758 25.3855 3.44767 25.8856C3.94777 26.3857 4.62605 26.6666 5.33329 26.6666H26.6666C27.3739 26.6666 28.0521 26.3857 28.5522 25.8856C29.0523 25.3855 29.3333 24.7072 29.3333 24V7.99998C29.3333 7.29274 29.0523 6.61446 28.5522 6.11436C28.0521 5.61426 27.3739 5.33331 26.6666 5.33331Z" fill="#5E5E5E" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default App;
